<template>
    <img src="../../img/toyota-admin-portal-logo.svg" alt="">
</template>
